import landing from './landing.json';

// Wording lives in landing.json so it can be edited without touching layout.
export const content = landing;

/** Replaces {name} placeholders; {fullControl} is always available. */
export function fill(text: string, vars: Record<string, string> = {}): string {
  const all: Record<string, string> = { fullControl: landing.fullControl, ...vars };
  return text.replace(/\{(\w+)\}/g, (m, key: string) => all[key] ?? m);
}

/** "Saturday 28 November" in Melbourne time, the cut-off's own time zone. */
export function formatCutoff(iso: string): string {
  const parts = new Intl.DateTimeFormat('en-AU', {
    timeZone: 'Australia/Melbourne',
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).formatToParts(new Date(iso));
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
  return `${get('weekday')} ${get('day')} ${get('month')}`;
}

/** The draw line, or null once the cut-off has passed (or if it isn't set). */
export function drawLine(now: Date = new Date()): string | null {
  const { consentBy, drawDay, prize, text } = landing.draw;
  const cutoff = Date.parse(consentBy);
  if (!text || Number.isNaN(cutoff) || now.getTime() > cutoff) return null;
  return fill(text, { consentBy: formatCutoff(consentBy), drawDay, prize });
}
